<template>
  <div class="info-page">
    <main>
      <section>
        <p>
          Das Projekt KomDat hat das Ziel, einen digitalen und datenbasierten
          Informationshub zu entwickeln, der Netzbetreiber, Gebäudeeigentümer und
          Mieter miteinander vernetzt. Durch den Austausch und die gemeinsame
          Analyse bereits vorhandener Daten sollen Synergien entstehen, die allen
          Beteiligten Vorteile bringen. Konkret hat sich das Projekt folgende
          Ziele gesetzt
        </p>
      </section>

      <section>
        <ul>
          <li>
            <strong>Datenaustausch fördern: </strong>
            Bisher isolierte Informationen werden zusammengeführt, um ein
            umfassenderes Bild zu erhalten.
          </li>
          <li>
            <strong>Kommunikation stärken: </strong>
            Ein Kommunikationskonzept unterstützt den offenen Austausch zwischen
            allen Akteuren.
          </li>
          <li>
            <strong>Vertrauen aufbauen: </strong>
            Durch transparente und faktenbasierte Informationen wird das
            Vertrauen zwischen Versorgern, Eigentümern und Mietern gestärkt.
          </li>
          <li>
            <strong>Energieeffizienz steigern: </strong>
            Gemeinsam werden Maßnahmen identifiziert, die den Energieverbrauch
            reduzieren und Kosten senken.
          </li>
        </ul>
      </section>

      <section>
        <h2 id="bezirke">Zählerdaten-Analysetools</h2>
        <p>
          Zählerdaten lassen sich häufig als .csv-Dateien über Webportale
          herunterladen oder direkt von Betreibern anfordern. Die Herausforderung
          dabei: Diese Daten folgen keinem einheitlichen Standard. Je nach
          Zählertyp können sich Einheiten unterscheiden, und Informationen wie
          Vor- und Rücklauftemperatur oder Volumenstrom sind manchmal enthalten
          und manchmal auch nicht. Eine einfache Berechnung – beispielsweise eine
          Energieanalyse aus Verbrauchsdaten – wird dadurch unnötig kompliziert.
        </p>
        <p>Um diese Hürden zu überwinden, bieten wir praktische Tools an:</p>
        <h3>1. Durchführung einer Energieanalyse aus Verbrauchsdaten</h3>
        <p>
          Anhand von Zählerdaten kann mit einigen Klicks eine vereinfachte
          Energieanalyse aus Verbrauchsdaten (EAV) durchgeführt werden. Diese
          verschafft Ihnen einen schnellen Überblick über die energetische
          Performance der Liegenschaft. Das bereitgestellte EAV-Tool arbeitet nur
          mit Zähler/Verbrauchs -daten und der Außentemperatur welche beim
          deutschen Wetterdienst abgefragt werden.
        </p>
        <h3>2. Der Datenkonverter</h3>
        <p>
          Der Datenkonverter macht aus uneinheitlichen Zählerdaten ein
          standardisiertes Format. Das Tool erkennt dabei automatisch anhand der
          Spaltennamen die entsprechenden Messvariablen und bietet die
          Möglichkeit alle Einheiten auf einen gemeinsamen Bereich zu bringen. So
          werden Zählerdatenaten vergleichbar und einfach weiterverwendbar.
        </p>
      </section>

      <div class="two-cols">
        <section>
          <h2 id="partner">Projektpartner</h2>
          <ul>
            <li>
              Fraunhofer-Institut für Optronik, Systemtechnik und Bildauswertung
              IOSB, Karlsruhe
            </li>
            <li>SEnerCon GmbH, Berlin</li>
            <li>KT-Elektronik GmbH, Berlin</li>
            <li>
              Institut für Ressourceneffizienz und Energiestrategien GmbH
              (IREES), Karlsruhe
            </li>
          </ul>
        </section>
        <section>
          <h2 id="steckbrief">Projektsteckbrief</h2>
          <div class="steckbrief">
            <div>
              <p>
                KomDat: Kommunikations- und Datenaustauschkonzept zwischen
                Fernwärmeversorger – Gebäudeeigentümer - Mieter
              </p>
              <div class="steckbrief-fact">
                <strong>Projektlaufzeit:</strong>
                <span> 7/2024 - 6/2027</span>
              </div>
              <div class="steckbrief-fact">
                <strong>Förderung:</strong>
                <span> Bundesministerium für Wirtschaft und Energie</span>
              </div>
              <div class="steckbrief-fact">
                <strong>Projektträger:</strong>
                <span> Projektträger Jülich (PtJ)</span>
              </div>
              <div class="steckbrief-fact">
                <strong>Förderkennzeichen:</strong>
                <span> 03EN3101A-D</span>
              </div>
            </div>
            <img :src="bmweLogoUrl" alt="Projekt Logo" class="steckbrief-logo">
          </div>
        </section>
      </div>

      <PageFooter />
    </main>
  </div>
</template>

<script>
import PageFooter from './PageFooter.vue'
import bmweLogoUrl from '../assets/BMWE_Logo.svg'
import '../styles/infopage.css'

export default {
  name: 'AboutPage',
  components: {
    PageFooter
  },
  data() {
    return { bmweLogoUrl }
  }
}
</script>
